"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProviderMergingLogic = exports.buildCusto = void 0;
/* eslint-disable react-hooks/rules-of-hooks */
const react_flexible_contexts_1 = require("react-flexible-contexts");
const objects_1 = require("../utils/objects");
const react_1 = require("react");
const weak_map_1 = require("../utils/weak-map");
const flags_1 = require("../flags");
const tree_1 = require("../classes/helper-fns/tree");
function buildCusto({ defaultValue, defaultMergeFlags, layerTransformationHook = (x => x), contextDisplayName, rawToFinalValueHook, mergeDecisionFn, }) {
    const memoContainer = new weak_map_1.MultiDimentionalWeakMap(4);
    const contextDrfaultValue = defaultValue === undefined
        ? undefined
        : {
            mergeFlags: defaultMergeFlags !== null && defaultMergeFlags !== void 0 ? defaultMergeFlags : [],
            value: defaultValue,
        };
    const Container = react_flexible_contexts_1.StackedContext.create(contextDrfaultValue, "value", {
        rawToFinalValueHook,
    });
    if (contextDisplayName) {
        Container.context.setContextName(contextDisplayName);
    }
    /* const FullValueProvider = Container.context.Provider;

    const FullNonMergingProvider = Container.addProvider<LayerData>(
        wrapInMeta(layerTransformationHook, () => ({ mergeFlags: undefined }))
    ); */
    // merges everything
    const PartialMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
        transformationHook: layerTransformationHook,
        memoContainer,
        mergeDecisionFn,
    }));
    // merges everything except default value
    const PartialNonPackageMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
        transformationHook: layerTransformationHook,
        memoContainer,
        avoidPackageCustoMerging: true,
        mergeDecisionFn,
    }));
    window.mergingMemoContainer = memoContainer;
    // does not merge anything
    const PartialNonMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
        transformationHook: layerTransformationHook,
        memoContainer,
        avoidNonPackageCustoMerging: true,
        avoidPackageCustoMerging: true,
        mergeDecisionFn,
    }));
    const Providers = {
        PartialMergingProvider,
        PartialNonPackageMergingProvider,
        PartialNonMergingProvider,
        memoContainer,
    };
    const arr = [
        defaultValue ? tree_1.buildCustoTree(Container) : {},
        Providers,
    ];
    arr.Container = Container;
    Object.assign(arr, Providers);
    return arr;
}
exports.buildCusto = buildCusto;
exports.createProviderMergingLogic = ({ transformationHook = x => x, memoContainer = new weak_map_1.MultiDimentionalWeakMap(4), avoidNonPackageCustoMerging, avoidPackageCustoMerging, mergeFlags: defaultMergingFlags, mergeDecisionFn, }) => {
    let avoidCustomizationsMerging = false;
    if (avoidNonPackageCustoMerging && avoidPackageCustoMerging) {
        avoidCustomizationsMerging = true;
    }
    const mergeFlags = [...(defaultMergingFlags || [])];
    if (avoidNonPackageCustoMerging) {
        mergeFlags.push(flags_1.CustoMergeFlagEnum.avoidWithNonPackageValue);
    }
    if (avoidPackageCustoMerging) {
        mergeFlags.push(flags_1.CustoMergeFlagEnum.avoidWithPackageDefaultValue);
    }
    const getCurrentMetaHook = (customizations, prevMeta) => {
        return { mergeFlags };
    };
    const fn = (customizations, prevVal, mergedMeta) => {
        const transformed = transformationHook(customizations);
        const mergeFlags = mergedMeta.mergeFlags;
        const b = react_1.useMemo(() => {
            return objects_1.mergeCustomizations({
                object1: transformed,
                object2: prevVal,
                memoContainer,
                mergeStrategy: "overrideLeftToRight",
                avoidCustomizationsMerging,
                mergeFlags,
                decisionFn: mergeDecisionFn,
            });
        }, [transformed, prevVal]);
        return b;
    };
    return wrapInMeta(fn, getCurrentMetaHook);
};
const wrapInMeta = (getValueHook, getCurrentMetaHook) => {
    return (currentVal, prevValWithMeta) => {
        const currentMeta = getCurrentMetaHook(currentVal, prevValWithMeta.mergeFlags);
        const mergeFlags = react_1.useMemo(() => {
            return new Set([
                ...(currentMeta.mergeFlags || []),
                ...(prevValWithMeta.mergeFlags || []),
            ]);
        }, [currentMeta, prevValWithMeta.mergeFlags]);
        const mergedMeta = react_1.useMemo(() => ({
            mergeFlags,
        }), [mergeFlags]);
        const value = getValueHook(currentVal, prevValWithMeta.value, mergedMeta);
        return react_1.useMemo(() => (Object.assign({ value }, mergedMeta)), [mergedMeta, value]);
    };
};
